import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      return;
    }
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return <>{children}</>;
};

export default ScrollToTop;
